export default __webpack_public_path__ + "static/media/2297.fd2cd767.png";